export default __webpack_public_path__ + "static/media/a.2cc11aeb.jpg";